module.exports = __webpack_public_path__ + "assets/img/xh.4226aaa3.png";